import React from "react";

// Plate colors for dishes without a photo, picked by the dish id so each keeps its own.
const PLATES = [
  ["#E9A54B", "#7A3B12", "#3E7D2A"],
  ["#8CC56B", "#2E6B1E", "#F2E6C9"],
  ["#6B3F7A", "#F2E6C9", "#D9343D"],
  ["#FBEFF3", "#D2335C", "#7FA35A"],
  ["#F7E26B", "#3E7D2A", "#C2352B"],
];

const plateFor = (seed) => {
  const s = String(seed ?? "");
  let h = 0;
  for (let i = 0; i < s.length; i += 1) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return PLATES[h % PLATES.length];
};

/**
 * A dish on a round plate: the dish's photo cropped to a circle, or a drawn plate when
 * the dish has no photo. With `fill` the photo covers its whole parent instead (a drawn
 * plate is centred on a plain background).
 */
const DishImage = ({ src, alt = "", seed, size = 104, className = "", fill = false }) => {
  if (fill && src) {
    return (
      <img
        src={src}
        alt={alt}
        loading="lazy"
        className={`w-full h-full object-cover bg-secondary ${className}`}
      />
    );
  }
  if (fill) {
    return (
      <div className={`w-full h-full flex items-center justify-center bg-secondary ${className}`}>
        <DishImage src={src} alt={alt} seed={seed} size={size} />
      </div>
    );
  }
  if (src) {
    return (
      <div className={`relative flex-none ${className}`} style={{ width: size, height: size }}>
        <img
          src={src}
          alt={alt}
          loading="lazy"
          className="w-full h-full rounded-full object-cover bg-secondary border-4 border-surface shadow-card"
        />
      </div>
    );
  }
  const [food, dot, dot2] = plateFor(seed);
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      className={`flex-none ${className}`}
      role="img"
      aria-label={alt}
    >
      <ellipse cx="50" cy="95" rx="34" ry="4" fill="#1F1A1A" opacity="0.10" />
      <circle cx="50" cy="48" r="44" fill="#FFFFFF" stroke="#F0ECEC" strokeWidth="2" />
      <circle cx="50" cy="48" r="30" fill={food} />
      <circle cx="41" cy="41" r="6" fill={dot} />
      <circle cx="59" cy="54" r="5" fill={dot} />
      <circle cx="57" cy="37" r="3.5" fill={dot2} />
      <circle cx="43" cy="57" r="3.5" fill={dot2} />
    </svg>
  );
};

export default DishImage;
